import Header from "../../components/layout/Header/Header";
import Layout from "../../components/layout/Layout/Layout";
import { Subscription } from "../../components/layout/Subscription/Subscription";


export default function SubscriptionPage() {
  return (
    <Layout>
      <Header></Header>
      <Subscription></Subscription>
    </Layout>
  );
}
